$(function () {
  handleOfficeAssessment();
});

function handleOfficeAssessment() {
  const content = $("#page-quiz-content-swap");
  const typeform = $("#page-quiz-typeform-swap");

  $("#page-quiz-typeform-cta").click(function () {
    history.pushState(null, null, "#form");
    content.css("display", "none");
    typeform.css("display", "block");
  });

  if (location.hash === "#form") {
    content.css("display", "none");
    typeform.css("display", "block");
  } else {
    content.css("display", "flex");
    typeform.css("display", "none");
  }

  window.addEventListener("popstate", function () {
    if (location.hash === "#form") {
      content.css("display", "none");
      typeform.css("display", "block");
    } else {
      content.css("display", "flex");
      typeform.css("display", "none");
    }
  });
}
